(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lh-stock-alternatives"] && !Shopify.designMode) return;
  try {
    function lhSelectAlternatives(entries, size) {
    var requested = String(size || '').trim().toLowerCase();
    return entries.reduce(function (matches, entry) {
      if (matches.length >= 4) return matches;
      var variants = entry.variants.filter(function (variant) {
        return variant.available && (!requested || String(variant.size || '').trim().toLowerCase() === requested);
      }).sort(function (a, b) { return a.price - b.price; });
      if (variants.length) matches.push({ entry: entry, variant: variants[0] });
      return matches;
    }, []);
  }

  function lhInitAlternatives(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    var entries = Array.from(root.querySelectorAll('[data-lh-alt-card]'), function (element) {
      return { element: element, variants: JSON.parse(element.dataset.variants) };
    });
    var sizeIndex = Number(root.dataset.sizeIndex);
    function update(size) {
      var matches = lhSelectAlternatives(entries, size);
      entries.forEach(function (entry) { entry.element.hidden = true; });
      matches.forEach(function (match) {
        var card = match.entry.element;
        card.href = match.variant.url;
        card.querySelector('[data-lh-alt-price]').textContent = match.variant.priceText;
        var image = card.querySelector('img');
        if (image && match.variant.image) { image.removeAttribute('srcset'); image.src = match.variant.image; }
        card.hidden = false;
      });
      root.hidden = matches.length === 0;
      var label = size ? root.dataset.sizeLabel + ' ' + size : root.dataset.allSizesLabel;
      root.querySelector('[data-lh-alt-selection]').textContent = label;
    }
    var picker = sizeIndex >= 0 ? document.querySelector('.lh-size-opts[data-option-pos="' + sizeIndex + '"] .lh-size-btn.active') : null;
    update(picker ? picker.dataset.value : root.dataset.selectedSize);
    var controller = new AbortController();
    document.addEventListener('lh:variant-change', function (event) {
      if (String(event.detail.productId) === root.dataset.productId) update(sizeIndex >= 0 ? event.detail.options[sizeIndex] : '');
    }, { signal: controller.signal });
    document.addEventListener('shopify:section:unload', function (event) {
      if (event.target.contains(root)) controller.abort();
    }, { signal: controller.signal });
  }

  function lhInitStockAlternativeRows(scope) {
    scope.querySelectorAll('[data-lh-alternatives]').forEach(lhInitAlternatives);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { lhInitStockAlternativeRows(document); }, { once: true });
  else lhInitStockAlternativeRows(document);
  document.addEventListener('shopify:section:load', function (event) { lhInitStockAlternativeRows(event.target); });
  } catch(e) { console.error(e); }
})();

})();
